module.exports = __webpack_public_path__ + "fonts/Inter-900-greek-ext62.2329210.woff2";